import React, { Fragment, useState } from 'react'
import { calcularTotal } from '../helpers';


//TODO: 04 Aplicamos dytrocion
const Formulario = (props) => {

    const {cantidad, guardarCantidad, plazo, guardarPlazo, guardarTotal, guardarCargando} = props;

    //Definir state
    const [error, guardarError] = useState(false);


    const leerCantidad = (e) => {
        //DE ESTA FORMO PUEDO OBTENER LO QUE EL USUARIO ESTA ESCRIBIENDO.
        console.log(e.target.value);
        //EL State es lo que hace a react mas Rapido...
        //TODO: 03 cada vez que cambienos d eactidad este se mostrara en el State.
        guardarCantidad(parseInt(e.target.value));
    }

    const leerSelect = (e) => {
        //DE ESTA FORMO PUEDO OBTENER LO QUE EL USUARIO ESTA ESCRIBIENDO.
        console.log(e.target.value);
        //EL State es lo que hace a react mas Rapido...
        //TODO: 03 cada vez que cambienos d eactidad este se mostrara en el State.
        guardarPlazo(parseInt(e.target.value));
    }


    const calcularPrestamo = e => {
        e.preventDefault();

        
        //VALIDAMOS
        if (cantidad === 0 || plazo === '') {
            guardarError(true);
            return; //para que no se ejecute la siguiente linea hast q este correcto.
        }

        //eliminar el error previo.
        guardarError(false);

        //Hbilitar el Spinner
        guardarCargando(true);

        setTimeout( () => {
            //RALIZAMOS LA COTIZACION.
            const total = calcularTotal(cantidad, plazo);
            //Una vez calculado, guardamosTotal.
            guardarTotal(total);

            //desabilitar el Spinner
            guardarCargando(false);
        }, 3000);



    }


    return ( 

        //TODO: evento cuando se de click al boton de carcular en el formualrio...
        <Fragment>
        <form onSubmit={ calcularPrestamo } >

          <div className="row">
              <div>
                  <label>Cantidad Prestamo</label>
                  <input 
                      className="u-full-width" 
                      type="number" 
                      placeholder="Ejemplo: 3000" 
                      
                      //TODO: 2 Estara en eschucha y llamara a la funcio..
                      onChange={ leerCantidad}

                  />
              </div>
              <div>
                  <label>Plazo para Pagar</label>
                  <select 
                      className="u-full-width"
                      onChange={ leerSelect }
                    >
                      <option value="">Seleccionar</option>
                      <option value="3">3 meses</option>
                      <option value="6">6 meses</option>
                      <option value="12">12 meses</option>
                      <option value="24">24 meses</option>
                  </select>
              </div>
              <div>
                  <input 
                      type="submit" 
                      value="Calcular" 
                      className="button-primary u-full-width" 
                  />
              </div>
          </div>
        </form>

        {(error) ?  <p className="error">Todos los campos son obligatorio </p>  : null}
        

        </Fragment>

    );
}
 
export default Formulario;
